import MoviesPage from 'pages/MoviesPage/MoviesPage'

export default MoviesPage
